<template>
  <div class="flex w-full flex-col items-center space-y-6 p-28">
    <icon-base :icon="IconScorecardsEmpty" width="120" height="120" />
    <lf-h2 class="-mb-0">
      {{ isGroups ? $t("SCORECARD_GROUPS.EMPTY") : $t("SCORECARDS.EMPTY") }}
    </lf-h2>
    <primary-button
      v-if="!isWorkflowBuilder && canCreateScorecard && canRunAnyScorecard"
      @click="handleNewTemplate"
    >
      {{
        isGroups
          ? $t("SCORECARD_GROUPS.CREATE_NEW")
          : $t("SCORECARDS.CREATE_NEW")
      }}
    </primary-button>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";

import { Ability, PermissionSubject } from "@/enums/auth";
import { ScorecardsIsWorkflowBuilder } from "@/helpers/symbols";
import { usePermissions } from "@/hooks/auth";
import { useDeals } from "@/hooks/deals";
import { useActiveStage } from "@/hooks/workflow";

import IconScorecardsEmpty from "../icons/IconScorecardsEmpty.vue";
import IconBase from "../ui/IconBase.vue";
import PrimaryButton from "../ui/buttons/PrimaryButton.vue";

defineProps({
  isGroups: {
    type: Boolean,
    default: false,
  },
});

const { canPerformActionReactive } = usePermissions();
const { activeStage } = useActiveStage();
const { activeDeal } = useDeals();

const emit = defineEmits<{
  (eventName: "newTemplate"): void;
}>();

const canCreateScorecard = canPerformActionReactive(
  PermissionSubject.scoreCard,
  Ability.create,
  {}
);

const canRunAnyScorecard = canPerformActionReactive(
  PermissionSubject.scoreCard,
  Ability.runAny,
  {
    application: activeDeal.value.id,
    scoreCardStageId: activeStage.value?.id,
  }
);

const isWorkflowBuilder = inject(ScorecardsIsWorkflowBuilder);

const handleNewTemplate = () => {
  emit("newTemplate");
};
</script>
